import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

import { SharedLanguageService } from '@language';
import {
    ApiFragment,
    ExportLocation,
    ExportLocationImageOptions,
    ExportLocationOptions,
    ExportRequest,
    ExportRequestEntry,
    ExportSource,
    ExportTagType
} from '@stylehaven/components';

@Injectable({ providedIn: 'root' })
export class ExportRequestService {
    constructor(
        private readonly datePipe: DatePipe,
        protected translateService: SharedLanguageService
    ) {}

    public exportLocationToExportRequest(
        exportLocation: ExportLocation,
        records: ApiFragment[],
        exportSource: ExportSource,
        exportReason?: string,
        imageTransformation?: ExportLocationImageOptions
    ): ExportRequest {
        const exportName: string | undefined = this.getExportName(records);
        const exportRequestEntries: ExportRequestEntry[] = records.map(this.recordsToExportRequestEntry);
        const options: ExportLocationOptions = this.mergeExportOptions(imageTransformation);

        const exportRequest: ExportRequest = {
            Filename: exportName,
            ExportLocationId: exportLocation.Id,
            Records: exportRequestEntries,
            ExportSource: exportSource,
            Reason: exportReason,
            Options: options,
            Tag: ExportTagType.Download
        };

        return exportRequest;
    }

    private getExportName(records: ApiFragment[]): string | undefined {
        const allSelectionTypes: boolean = records.every(record => record.isSelection());

        if (allSelectionTypes) {
            return this.translateService.translate('exportjob.selection-export', {
                datestamp: this.datePipe.transform(new Date(), 'yyyyMMddHHmmss')
            });
        }

        if (records.length === 1) {
            return undefined;
        }

        return this.translateService.translate('exportjob.bulk-download-items', {
            datestamp: this.datePipe.transform(new Date(), 'yyyyMMddHHmmss')
        });
    }

    private recordsToExportRequestEntry(record: ApiFragment): ExportRequestEntry {
        return { RecordId: record.getFragmentId() };
    }

    private mergeExportOptions(imageTransformation?: ExportLocationImageOptions): ExportLocationOptions {
        const exportLocationOptions: ExportLocationOptions = {};

        if (!imageTransformation) {
            return exportLocationOptions;
        }

        return { ...exportLocationOptions, Image: imageTransformation };
    }
}
